var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.95908C15.0028 9.03967 14.7503 10.1056 14.2631 11.0702C13.6855 12.226 12.7974 13.1982 11.6985 13.8778C10.5995 14.5574 9.33305 14.9176 8.04092 14.9181C6.96033 14.9209 5.89435 14.6685 4.92982 14.1813L1 15L1.81871 11.0702C1.33152 10.1056 1.07905 9.03967 1.08187 7.95908C1.08237 6.66695 1.4426 5.40048 2.12222 4.30152C2.80184 3.20256 3.774 2.31452 4.92982 1.73686C5.89435 1.24967 6.96033 0.997206 8.04092 1.00002H8.45028C10.1568 1.09417 11.7686 1.81445 12.9771 3.02295C14.1856 4.23144 14.9058 5.84324 15 7.54972V7.95908Z",
    stroke: "inherit",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92355 9.89474C5.71492 9.89474 6.10397 9.488 6.10397 8.94863C6.10397 7.84779 4.41071 8.16169 4.41071 7.69748C4.41071 7.52063 4.56102 7.40569 4.82628 7.40569C5.12692 7.40569 5.44523 7.50737 5.68397 7.72842L6.03323 7.25979C5.74144 6.99011 5.35239 6.84863 4.88376 6.84863C4.18965 6.84863 3.76523 7.25537 3.76523 7.74611C3.76523 8.85579 5.46292 8.49769 5.46292 9.01053C5.46292 9.18295 5.29934 9.33769 4.95007 9.33769C4.54334 9.33769 4.2206 9.152 4.01281 8.93537L3.66797 9.42611C3.9465 9.70463 4.35323 9.89474 4.92355 9.89474Z",
    fill: "inherit",
    stroke: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71866 9.84169V6.89284H8.83445L8.11824 8.73642L7.40203 6.89284H6.52224V9.84169H7.15003V7.71516L7.98119 9.84169H8.25529L9.08645 7.71516V9.84169H9.71866Z",
    fill: "inherit",
    stroke: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3565 9.89474C12.1479 9.89474 12.5369 9.488 12.5369 8.94863C12.5369 7.84779 10.8437 8.16169 10.8437 7.69748C10.8437 7.52063 10.994 7.40569 11.2593 7.40569C11.5599 7.40569 11.8782 7.50737 12.1169 7.72842L12.4662 7.25979C12.1744 6.99011 11.7854 6.84863 11.3167 6.84863C10.6226 6.84863 10.1982 7.25537 10.1982 7.74611C10.1982 8.85579 11.8959 8.49769 11.8959 9.01053C11.8959 9.18295 11.7323 9.33769 11.3831 9.33769C10.9763 9.33769 10.6536 9.152 10.4458 8.93537L10.1009 9.42611C10.3795 9.70463 10.7862 9.89474 11.3565 9.89474Z",
    fill: "inherit",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.0003ee58.svg";
export { ForwardRef as ReactComponent };